module.exports = __webpack_public_path__ + "img/image5.2.2618a51f.png";